import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "@jobber/design/foundation.css";

const domNode = document.getElementById("root") as HTMLElement;
const root = createRoot(domNode);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);